"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aggius": {
    "8079c749": [{
      "hkey": "e68f90ff",
      "slug": "aggius",
      "name": "Aggius",
      "primary": true,
      "skipSearch": false
    }],
    "pala-di-monti": [{
      "hkey": "e68f90ff",
      "slug": "aggius",
      "name": "Aggius",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b2964c7": [{
      "hkey": "e68f90ff",
      "slug": "aggius",
      "name": "Aggius",
      "primary": true,
      "skipSearch": false
    }],
    "vintura": [{
      "hkey": "e68f90ff",
      "slug": "aggius",
      "name": "Aggius",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;